import React, { useState } from 'react'
import Catalog from 'blocks.app/catalog/catalog'
import { AUTHORS_CATALOG_CONFIG, CatalogizatorSelectedItems } from '../InstancesCatalogCatalogizator-types'

export const InstancesCatalogAuthors = () => {
    const [selectedItems, setSelectedItems] = useState<CatalogizatorSelectedItems>([])

    return (
        <Catalog
            type={AUTHORS_CATALOG_CONFIG.type}
            onSelect={setSelectedItems}
            selectedItems={selectedItems}
            treeView={AUTHORS_CATALOG_CONFIG.treeView}
            additionalData={AUTHORS_CATALOG_CONFIG.additionalData}
            fixedHeader={AUTHORS_CATALOG_CONFIG.fixedHeader}
            isExistRightToolbar={AUTHORS_CATALOG_CONFIG.isExistRightToolbar}
            hideHeader={AUTHORS_CATALOG_CONFIG.hideHeader}
        />
    )
}
